<script setup>
import { router } from '@inertiajs/vue3';
import InputField from '@js/components/fields/InputField.vue';
import FormColumn from '@js/components/forms/FormColumn.vue';
import FormContent from '@js/components/forms/FormContent.vue';
import FormFooter from '@js/components/forms/FormFooter.vue';
import FormGrid from '@js/components/forms/FormGrid.vue';
import FormRoot from '@js/components/forms/FormRoot.vue';
import { useRoute } from '@js/utils/route';
import { toastError, toastSaved } from '@js/utils/toast';
import { reactive, ref } from 'vue';
import { object, string } from 'yup';

const { tenant, configuration } = defineProps({
    tenant: {
        type: Object,
        required: true,
    },
    configuration: {
        type: Object,
        required: true,
    },
});

const { route } = useRoute();

const isSubmitting = ref(false);

const form = reactive({
    width: configuration.data.width,
    height: configuration.data.height,
});

const validationSchema = object({
    width: string().required('La largeur est requise'),
    height: string().required('La hauteur est requise'),
});

function submit() {
    isSubmitting.value = true;

    axios
        .post(
            route('front.projectManagement.ai.postProductImagesConfiguration', {
                tenant: tenant.id,
            }),
            {
                width: form.width,
                height: form.height,
            },
        )
        .then(() => {
            toastSaved();

            router.visit(window.location.href);
        })
        .finally(() => {
            isSubmitting.value = false;
        })
        .catch((error) => {
            toastError(error);

            router.visit(
                route('front.projectManagement.ai.productImages', {
                    tenant: tenant.id,
                }),
            );
        });
}
</script>

<template>
    <FormRoot
        v-slot="{ errors }"
        :validation-schema="validationSchema"
        :submit="submit"
    >
        <FormColumn>
            <FormContent>
                <FormGrid :columns="2">
                    <InputField
                        v-model="form.width"
                        label="Largeur (en pixels)"
                        field-name="width"
                        field-id="width"
                        type="number"
                        min="0"
                        required
                    />

                    <InputField
                        v-model="form.height"
                        label="Hauteur (en pixels)"
                        field-name="height"
                        field-id="height"
                        type="number"
                        min="0"
                        required
                    />
                </FormGrid>
            </FormContent>
        </FormColumn>

        <FormFooter :is-submitting="isSubmitting" :errors="errors" />
    </FormRoot>
</template>
